import React from 'react';
import TedImage from '../assets/Ted.jpg';
import BillImage from '../assets/BillImage.png';
import DavidImage from '../assets/DavidImage.png';
import LuImage from '../assets/Lu.png';
import GraceImage from '../assets/GraceImage.png';
import '../styles/BoardOfDirectors.css';
import { Breadcrumb } from 'semantic-ui-react';
import { Container, Row } from "react-bootstrap";

const breadcrumbSections = [
    { key: 'home', content: 'HOME', href: "/" },
    { key: 'investors', content: 'INVESTORS', href: "/investors" },
    { key: 'board', content: 'BOARD OF DIRECTORS', active: true },
]


function BoardOfDirectors() {


    return (
        <div className="whole-container">
            <div style={{ textAlign: 'left', marginLeft: '70px', marginTop: '80px' }}>
                <Breadcrumb icon='right angle' sections={breadcrumbSections} style={{ backgroundColor: '#fff' }} />
            </div>

            <div className="board-header">Board of Directors</div>

            
            <Container fluid className="board-container">

                
                <Row><div className="divider-middle"><hr /></div></Row>

                {/*TED*/}
                <Row className="justify-content-start align-items-start">
                    <div className='board-content'>
                        <div className='img-container'><img className="board-image" src={TedImage} alt="Ted Daniel" /> </div>
                        <div className='summary'>
                            <p className="name"> Ted Daniel</p>
                            <p className="job-title"> CEO, President, Director & Co-founder </p>
                            <p>
                                Since founding Titanium in 2002,Ted has led the growth of the Company from a start-up to
                                ~$500 Million in revenue including a U.S. expansion and 12 acquisitions. Prior to Titanium,
                                Ted led multiple turnarounds and restructurings as a CFO (10 years).
                                Ted is a Chartered Accountant formerly with KPMG and SLF. He holds a BA,
                                Comp Sci., HBBA, from York University.
                            </p>
                        </div>
                    </div>
                </Row>
                <Row><div className="divider-middle"><hr /></div></Row>

                {/*LU*/}
                <Row className="justify-content-start align-items-start">
                    <div className='board-content'>
                        <div className='img-container'><img className="board-image" src={LuImage} alt="Lu Glassaso" /> </div>
                        <div className='summary'>
                            <p className="name"> Lu Galasso</p>
                            <p className="job-title"> Chair of the Board of Directors </p>
                            <p>
                                More than 20 years of experience in the manufacturing sector. Partner with the Zzen Group of
                                Companies since 2004. Trusted advisor to Titanium Logistics since 2007.
                                A Chartered Accountant formerly with KPMG and Arthur Andersen
                            </p>
                        </div>
                    </div>
                </Row>
                <Row><div className="divider-middle"><hr /></div></Row>

                {/*GRACE*/}
                <Row className="justify-content-start align-items-start">
                    <div className='board-content'>
                        <div className='img-container'><img className="board-image" src={GraceImage} alt="Lu Glassaso" /> </div>
                        <div className='summary'>
                            <p className="name"> Grace Palombo</p>
                            <p className="job-title"> Chair of the HR and Compensation Committee </p>
                            <p>
                                Ms. Palombo currently holds the position of Executive Vice President and Chief Human Resources Office
                                for Great-West Lifeco. Prior to joining Great-West Lifeco in 2014, she was an integral part
                                of the senior leadership teams at TD Bank in Canada and US, CanWest Media Inc.,
                                Husky Injection Molding, Union Gas and Canada Life. With a legal background and
                                specialization in human resources and compensation, Ms. Palombo has also served on several boards
                                in the past, notably for Student Transportation of America and Enercare Inc. In 2018,
                                Ms. Palombo was named one of Canada's Top 100 Most Powerful Women by the Women's Executive Network
                            </p>
                        </div>
                    </div>
                </Row>
                <Row><div className="divider-middle"><hr /></div></Row>

                {/*WILL*/}
                <Row className="justify-content-start align-items-start">
                    <div className='board-content'>
                        <div className='img-container'><img className="board-image" src={BillImage} alt="William (Bill) Chyfetz" /> </div>
                        <div className='summary'>
                            <p className="name"> William (Bill) Chyfetz </p>
                            <p className="job-title"> Chair of Audit Committee </p>
                            <p>
                                Served as Vice President and Secretary of Progressive Waste Solutions Ltd. (TSX: BIN) and
                                its predecessors from 2000 to 2014; also held role of General Counsel from 2000 to 2010 and
                                Associate General Counsel from 2010 to 2014
                            </p>
                        </div>
                    </div>

                </Row>
                <Row><div className="divider-middle"><hr /></div></Row>

                {/*DAVID*/}
                <Row className="justify-content-start align-items-start">
                    <div className='board-content'>
                        <div className='img-container'><img className="board-image" src={DavidImage} alt="David Bradley" /> </div>
                        <div className='summary'>
                            <p className="name"> David Bradley</p>
                            <p className="job-title"> Non-Executive Director </p>
                            <p>
                                Voice of trucking in Canada and Ontario for the better part of 3 decades until his retirement
                                at the end of 2017 as the CEO of both the Canadian Trucking Alliance and the Ontario Trucking
                                Association. Previously was a Management consultant with Touche Ross & Partners (1982-84) and
                                Financial markets economist with the Bank of Nova Scotia (1984-85).
                                Fellow of the Chartered Institute of Logistics and Transportation
                            </p>
                        </div>
                    </div>
                </Row>
                <Row><div className="divider-middle"><hr /></div></Row>

                

                

            </Container>

        </div>

    )
}

export default BoardOfDirectors
